import * as React from 'react';

import type WorkSummaryStatusVM from 'ab-viewModels/workOrder/workSummaryStatus.viewModel';

import * as TimeUtils from '@acceligentllc/shared/utils/time';

import { TimeFormat } from '@acceligentllc/shared/enums/timeFormat';
import { WorkSummaryStatus as WorkSummaryStatusEnum } from '@acceligentllc/shared/enums/workSummaryStatus';

import { bemBlock } from 'af-utils/bem.util';

interface Props {
	status: WorkSummaryStatusVM;
}

const _resolveWorkSummaryStatus = (workSummaryStatus: WorkSummaryStatusEnum) => {
	switch (workSummaryStatus) {
		case WorkSummaryStatusEnum.DRAFT: {
			return (
				<span className={bemBlock('field-report__work-summary__status', { draft: true })}>
					Draft
				</span>
			);
		}
		case WorkSummaryStatusEnum.IN_PROGRESS: {
			return (
				<span className={bemBlock('field-report__work-summary__status', { 'in-progress': true })}>
					In Progress
				</span>
			);
		}
		case WorkSummaryStatusEnum.OUTDATED: {
			return (
				<span className={bemBlock('field-report__work-summary__status', { outdated: true })}>
					Outdated
				</span>
			);
		}
		case WorkSummaryStatusEnum.REVIEWED: {
			return (
				<span className={bemBlock('field-report__work-summary__status', { reviewed: true })}>
					Reviewed
				</span>
			);
		}
		case WorkSummaryStatusEnum.COMPLETED: {
			return (
				<span className={bemBlock('field-report__work-summary__status', { completed: true })}>
					Completed
				</span>
			);
		}
	}
};

const WorkSummaryStatus: React.FC<Props> = (props) => {
	const { status: { status, lastUpdatedAt, lastUpdatedBy } } = props;
	let localTimeLastUpdatedAt: Nullable<string> = null;

	if (lastUpdatedAt) {
		const browserOffset = (new Date()).getTimezoneOffset();
		const timeInIso = TimeUtils.formatDate(lastUpdatedAt, TimeFormat.ISO_DATETIME, TimeFormat.FULL_DATE);

		localTimeLastUpdatedAt = TimeUtils.offsetTime(timeInIso, -browserOffset, 'minutes', TimeFormat.FULL_DATE_LONG);
	}

	const updatedInfo = (localTimeLastUpdatedAt && lastUpdatedBy)
		? `${localTimeLastUpdatedAt} By ${lastUpdatedBy}`
		: '';

	return (
		<div className="field-report__work-summary__status-container">
			{_resolveWorkSummaryStatus(status)}
			<span>{updatedInfo}</span>
		</div>
	);
};

export default React.memo(WorkSummaryStatus);
